const DEFAULT_ALLOWED_PROTOCOLS = ['http:', 'https:'];

function removeSchemeObfuscationChars(text) {
  return Array.from(text)
    .filter((char) => {
      const code = char.charCodeAt(0);
      return code > 0x1f && code !== 0x7f && !/\s/.test(char);
    })
    .join('');
}

export function normalizeSafeUrl(
  value,
  {
    allowRelative = true,
    allowedProtocols = DEFAULT_ALLOWED_PROTOCOLS,
    baseUrl = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : 'https://integra3646.com',
  } = {}
) {
  if (typeof value !== 'string') {
    return '';
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }

  const compactSchemeCheck = removeSchemeObfuscationChars(trimmed).toLowerCase();
  if (/^(javascript|data|vbscript):/.test(compactSchemeCheck)) {
    return '';
  }

  try {
    const parsed = new URL(trimmed, baseUrl);
    if (!allowedProtocols.includes(parsed.protocol)) {
      return '';
    }

    if (!allowRelative && parsed.origin === new URL(baseUrl).origin && !/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) {
      return '';
    }

    return trimmed;
  } catch (_err) {
    return '';
  }
}
